import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@/components/General/InfoCard/infoCard"
    ).then((module) => ({
        default: module.InfoCard
    }))
);
